export default {
  container: {
    padding: [4, 12, 0],
  },

  image: {
    margin: [0, -12, 20],
    backgroundColor: '#c7c7c7',
    width: 'calc(100% + 24px)',
    display: 'block',
    height: 194,
    marginBottom: 12,
    objectFit: 'cover',
  },

  title: {
    marginBottom: 12,
    fontFamily: 'Giorgio Sans',
    fontWeight: 'bold',
    fontSize: 27,
    lineHeight: 1.1,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    wordWrap: 'break-word',
  },

  additionalText: {
    fontFamily: 'Graphik LCG',
    fontSize: 10,
    lineHeight: 1.1,
    wordWrap: 'break-word',
  },
};
